var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporteHistorico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 10c0-1.1.9-2 2-2h20.8L44 17.2V52c0 1.1-.9 2-2 2H14c-1.1 0-2-.9-2-2V10zm24.6 3.4L36.6 13H14v37h28V13.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36 8h2.8L44 13.2V11c0-1.1-.9-2-2-2h-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 22h16v3.2H18V22zm0 7.2h13v3.2H18v-3.2zm0 7.2h9.5v3.2H18v-3.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.5 36.8a8.2 8.2 0 1 0 11.6 11.6l6.8 6.8-2.3 2.3-6.8-6.8A8.2 8.2 0 0 0 39.5 36.8zm1.6 1.6a5.4 5.4 0 1 1 0 7.6 5.4 5.4 0 0 1 0-7.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporteHistorico);
export default __webpack_public_path__ + "static/media/reporte-historico.8bc76bc94d3c085887a8fce817ccc300.svg";
export { ForwardRef as ReactComponent };